namespace OSF {
  // Since XmlProcessor can't support xpath query, here we write a method to select grandchild (or deeper) level descendant node.
  export function SelectSingleNode(
    xmlProcessor: OSF.XmlProcessor,
    node: any,
    path: Array<string>,
    isStrictPath?: boolean,
  ): any {
    if (path == null) return node;
    let currentNode: any = node;
    for (let i: number = 0; i < path.length; i++) {
      currentNode = xmlProcessor.selectSingleNode(path[i], currentNode);
      if (currentNode == null) {
        if (isStrictPath) {
          return null;
        }
        break;
      }
    }
    return currentNode;
  }

  // Similar to SelectSingleNode, select grandchild (or deeper) level descendant nodes.
  export function SelectChildNodes(
    xmlProcessor: OSF.XmlProcessor,
    name: string,
    node: any,
    path: Array<string>,
    isStrictPath?: boolean,
  ): any {
    let currentNode: any = SelectSingleNode(xmlProcessor, node, path, isStrictPath);
    if (currentNode == null) {
      return [];
    }
    return xmlProcessor.selectNodes(name, currentNode);
  }

  // Convert the number to string for VersionOverrides' version.
  export function GetVersionOverridesString(versionOverridesNumber: OSF.VersionOverridesNumber): string {
    let versionString = "";
    if (
      versionOverridesNumber >= OSF.VersionOverridesNumber.V1_0 &&
      versionOverridesNumber < OSF.VersionOverridesNumber.Max
    ) {
      versionString =
        "VersionOverridesV" + Math.floor(versionOverridesNumber / 100) + "_" + (versionOverridesNumber % 100);
    }
    return versionString;
  }

  // From the VersionOverrides' version as a number in enum, get its node path.
  export function GetVersionOverridesPath(
    xmlProcessor: OSF.XmlProcessor,
    namespace: string,
    versionOverridesNumber: OSF.VersionOverridesNumber,
  ): string[] {
    let path: string[] = [];
    if (
      versionOverridesNumber >= OSF.VersionOverridesNumber.V1_0 &&
      versionOverridesNumber < OSF.VersionOverridesNumber.Max
    ) {
      for (const v in OSF.VersionOverridesNumber) {
        let versionNumber = Number(v);
        if (!isNaN(versionNumber) && versionNumber <= versionOverridesNumber) {
          let ns: string = namespace;

          // for Outlook's VersionOverrides 1.1 and above, we need to make sure the namespace is registered
          if (versionNumber > VersionOverridesNumber.V1_0) {
            ns = GetVersionOverridesNamespace(ns, versionNumber);
            xmlProcessor.addNamespaceMapping(
              ns.slice(0, -1),
              OSF.VersionOverridesNamespace[VersionOverridesNumber[versionNumber]],
            );
          }

          path.push(ns + OSF.ParserStrings.VersionOverrides);
        }
      }
    }
    return path;
  }

  export function GetVersionOverridesNamespace(
    namespace: string,
    versionOverridesNumber?: OSF.VersionOverridesNumber,
  ): string {
    let ns: string = namespace;
    if (
      versionOverridesNumber != null &&
      versionOverridesNumber > VersionOverridesNumber.V1_0 &&
      ns === OSF.ParserStrings.Mailappor
    ) {
      ns = OSF.ParserStrings.Mailappor.replace(":", VersionOverridesNumber[versionOverridesNumber] + ":");
    }
    return ns;
  }

  export function GetNamespaceOrDefault(namespace: string): string {
    if (namespace && namespace.length > 0) {
      return namespace;
    }
    return "ov:";
  }
}
